import React from 'react';
import { List, ListItem, ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

const Sidebar = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const items = [
    { name: 'Dashboard', path: '/dashboard' },
    { name: 'Create Room', path: '/create_room' },
    { name: 'Join Room', path: '/join_room' },
    {name:'BizzFlow',path:'/bizzflow'},
    { name: 'BizzBoard', path: '/bizzboard' },

    { name: 'Universal GPT', path: '/universal_gpt' },
    { name: 'Bizz News', path: '/bizznews' },
    { name: 'Account', path: '/account' },
    
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 64px)', backgroundColor: theme.palette.black['900'] }}>
      <List component="nav" style={{   color: theme.palette.white['50'] }}>
        {items.map((item, index) => (
          <ListItem button key={index} onClick={() => navigate(item.path)} style={{ color: theme.palette.white['50'] }}>
            <ListItemText primary={item.name} />
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default Sidebar;
